import { Controller } from "@hotwired/stimulus"

// Hides all .spv_rows then shows only the ones matching the visible selectors.
// The visible-selectors value is a comma-separated list of CSS selectors.
export default class extends Controller {
  static values = { visibleSelectors: String }

  connect() {
    this.element.querySelectorAll('.spv_rows').forEach(row => row.style.display = 'none')

    if (this.visibleSelectorsValue) {
      this.element.querySelectorAll(this.visibleSelectorsValue).forEach(row => row.style.display = '')
    }
  }
}
